// extracted by mini-css-extract-plugin
export default {"mediaPage":"InnerPage_mediaPage__iug5i"};